import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { DlcoSessionListScreen } from "./DlcoSessionListScreen";
import { DlcoAnalysisScreen } from "./DlcoAnalysisScreen";
import { DlcoAnalysisListScreen } from "./DlcoAnalysisListScreen";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { SearchParams } from "../../Components/Query";

export const DlcoRoot = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <Switch>
            <PrivateRoute path="/Dlco" exact permissions={[PermissionEnum.AccessSingleDlcoSession, PermissionEnum.AccessAllDlcoSessions, PermissionEnum.OverreadDlcoSession]}>
                <DlcoSessionListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Dlco/Analysis" exact permissions={[PermissionEnum.OverreadDlcoSession]}>
                <DlcoAnalysisListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
            </PrivateRoute>
            <PrivateRoute path="/Dlco/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadDlcoSession, PermissionEnum.AccessSingleDlcoSession]}>
                <DlcoAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
